import { fetchDeleteOrgList } from '@/routes/ExceptionRecord/services';

export default {
  namespace: 'DeleteOrgManage',
  state: {},
  effects: {
    // 获取已删除单位列表
    * fetchDeleteOrgList ({ payload }, { call }) {
      try {
        return yield call(fetchDeleteOrgList, payload);
      }catch (e) {}
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
